// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import PlanMatcherController from "./plan_matcher_controller"
import AbleMatcherController from "./able_matcher_controller"
import TrumpAccountMatcherController from "./trump_account_matcher_controller"
import ProgramsController from "./programs_controller"
import OrganizationTypeController from "./organization_type_controller"
import SkyflowBankFieldsController from "./skyflow_bank_fields_controller"
import { Datepicker } from "stimulus-datepicker"

application.register("hello", HelloController)
application.register("datepicker", Datepicker)
application.register("plan-matcher", PlanMatcherController)
application.register("able-matcher", AbleMatcherController)
application.register("trump-account-matcher", TrumpAccountMatcherController)
application.register("organization-type", OrganizationTypeController)
application.register("programs", ProgramsController)
application.register("skyflow-bank-fields", SkyflowBankFieldsController)
